import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full px-3 sm:px-6 py-6 space-y-6" }
const _hoisted_3 = {
  key: 0,
  class: "bg-white border border-gray-200 rounded-xl p-10 text-center"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-white border border-gray-200 rounded-xl p-5 sm:p-6 max-w-2xl"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm text-gray-600"
}
const _hoisted_6 = { class: "mt-6 border-t border-gray-200 pt-4" }
const _hoisted_7 = { class: "bg-white border border-gray-200 rounded-xl p-4 sm:p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4" }
const _hoisted_8 = { class: "text-sm text-gray-600 mt-1 break-all" }
const _hoisted_9 = { class: "flex flex-wrap gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "rounded-lg border border-blue-200 bg-blue-50 p-4 text-sm text-blue-800",
  role: "status"
}
const _hoisted_11 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_12 = {
  key: 1,
  class: "p-4 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700"
}
const _hoisted_13 = { class: "sticky top-[70px] z-30 bg-white/95 backdrop-blur border border-gray-200 rounded-lg px-3 py-2 flex flex-wrap items-center gap-2 shadow-sm" }
const _hoisted_14 = { class: "text-xs text-gray-500 shrink-0 whitespace-nowrap" }
const _hoisted_15 = { class: "relative flex-1 min-w-0" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "flex items-center gap-1.5 shrink-0 ml-auto" }
const _hoisted_18 = { class: "bg-white border border-gray-200 rounded-xl overflow-hidden" }
const _hoisted_19 = { class: "p-4 sm:p-5 border-b border-gray-200" }
const _hoisted_20 = { class: "font-semibold text-black" }
const _hoisted_21 = { class: "text-sm font-normal text-gray-500" }
const _hoisted_22 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_23 = {
  key: 1,
  class: "p-10 text-center text-gray-500"
}
const _hoisted_24 = {
  key: 2,
  class: "overflow-x-auto"
}
const _hoisted_25 = { class: "min-w-[1100px] w-full text-sm" }
const _hoisted_26 = { class: "bg-gray-50 text-left text-gray-600" }
const _hoisted_27 = { class: "px-3 py-3 w-10 sticky left-0 bg-gray-50 z-10" }
const _hoisted_28 = ["checked", "disabled"]
const _hoisted_29 = { class: "divide-y divide-gray-100" }
const _hoisted_30 = ["title", "onClick"]
const _hoisted_31 = ["checked", "onChange"]
const _hoisted_32 = { class: "px-3 py-3" }
const _hoisted_33 = ["title"]
const _hoisted_34 = { class: "px-3 py-3" }
const _hoisted_35 = ["src", "alt"]
const _hoisted_36 = {
  key: 1,
  class: "w-10 h-10 rounded bg-gray-100 border border-gray-200 flex items-center justify-center text-gray-400"
}
const _hoisted_37 = { class: "px-3 py-3 font-medium text-black whitespace-nowrap" }
const _hoisted_38 = { class: "px-3 py-3 text-black" }
const _hoisted_39 = { class: "px-3 py-3 text-gray-700 whitespace-nowrap" }
const _hoisted_40 = {
  key: 0,
  class: "ml-1 text-xs text-red-700"
}
const _hoisted_41 = { class: "px-3 py-3 text-gray-700" }
const _hoisted_42 = {
  key: 0,
  class: "ml-1 text-xs text-red-700"
}
const _hoisted_43 = { class: "px-3 py-3 text-right text-gray-700 whitespace-nowrap" }
const _hoisted_44 = { class: "px-3 py-3 text-right text-gray-700 whitespace-nowrap" }
const _hoisted_45 = { class: "px-3 py-3 text-gray-700 whitespace-nowrap" }
const _hoisted_46 = { class: "px-3 py-3 text-gray-700" }
const _hoisted_47 = { class: "px-3 py-3 text-gray-700" }
const _hoisted_48 = { class: "px-3 py-3 text-center text-gray-700" }
const _hoisted_49 = { class: "px-3 py-3" }
const _hoisted_50 = { class: "px-3 py-3 text-gray-600 max-w-[220px]" }
const _hoisted_51 = {
  key: 0,
  class: "text-green-700"
}
const _hoisted_52 = ["title"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_55 = {
  class: "relative bg-white rounded-xl shadow-xl max-w-lg w-full p-6",
  role: "dialog",
  "aria-labelledby": "shopify-connect-help-title"
}
const _hoisted_56 = { class: "mt-6 flex justify-end" }

import { computed, onMounted, provide, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import PageHeader from "@/components/layout/seller/PageHeader.vue";
import BaseInput from "@/components/forms/BaseInput.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import ConfirmModal from "@/components/common/ConfirmModal.vue";
import UnifiedPagination from "@/components/ui/UnifiedPagination.vue";
import ShopifyMelProductSheet from "@/components/shopify/ShopifyMelProductSheet.vue";
import ShopifyMelBulkSheet from "@/components/shopify/ShopifyMelBulkSheet.vue";
import ShopifyConfigurationModal from "@/components/shopify/ShopifyConfigurationModal.vue";
import { useAuthStore } from "@/stores/auth";
import { useNotification } from "@/composables/useNotification";
import { useBodyScrollLock } from "@/composables/useBodyScrollLock";
import type { ShopifyMelBulkSheetContext } from "@/composables/useShopifyMelBulkSheet";
import {
  disconnectShopify,
  getShopifyAuthorizeUrl,
  claimShopifyInstall,
  exportShopifyOrders,
  syncLinkedProductsFromShopify,
  getShopifyConnection,
  getShopifyCatalogStatus,
  getShopifyImportPreview,
  getShopifyProducts,
  importShopifyProductRowsInBatches,
  importShopifyProductsInBatches,
  toShopifyImportRow,
  resetAllShopifyProductOverrides,
  getShopifySettings,
  resolveShopifyCoverImageUrl,
  SHOPIFY_IMPORT_BATCH_SIZE,
  syncShopifyCatalogNextPage,
} from "@/api/shopify";
import type { ShopifyImportPreview } from "@/api/shopify";
import type {
  ShopifyCatalogPage,
  ShopifyConnection,
  ShopifyProduct,
} from "@/types/shopify";

const publishConfirmAttention =
  "Attention : merci de bien vérifier vos fiches avant de continuer (photos, catégories, compositions, couleurs, stocks, mode de vente, prix HT grossiste, etc.).";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopifyImportView',
  setup(__props) {

const authStore = useAuthStore();
const isAdmin = computed(() => authStore.isImpersonating);

const emptyCatalog = (): ShopifyCatalogPage => ({
  items: [],
  newProducts: [],
  total: null,
  hasMore: false,
  endCursor: null,
});

function normalizeProduct(raw: Partial<ShopifyProduct>): ShopifyProduct {
  return {
    id: raw.id ?? "",
    legacyResourceId: raw.legacyResourceId ?? "",
    title: raw.title ?? "",
    handle: raw.handle ?? "",
    vendor: raw.vendor ?? "",
    productType: raw.productType ?? "",
    shopifyCategoryName: raw.shopifyCategoryName ?? "",
    status: raw.status ?? "",
    tags: Array.isArray(raw.tags) ? raw.tags : [],
    createdAt: raw.createdAt ?? "",
    updatedAt: raw.updatedAt ?? "",
    description: raw.description ?? "",
    descriptionHtml: raw.descriptionHtml ?? "",
    descriptions: raw.descriptions ?? {},
    totalInventory: raw.totalInventory ?? 0,
    variantsCount: raw.variantsCount ?? 0,
    imageUrl: raw.imageUrl ?? null,
    imageIds: Array.isArray(raw.imageIds) ? raw.imageIds : [],
    images: Array.isArray(raw.images)
      ? raw.images.map((image) => ({
          id: String(image.id),
          url: String(image.url || ""),
          altText: image.altText ?? null,
          colorName: image.colorName ?? null,
          sourceColorName: image.sourceColorName ?? image.colorName ?? null,
        }))
      : [],
    reference: raw.reference ?? raw.handle ?? "",
    barcode: raw.barcode ?? null,
    name: raw.name ?? raw.title ?? "",
    active: raw.active ?? raw.status === "ACTIVE",
    price: raw.price ?? 0,
    shopifyPrice: raw.shopifyPrice ?? raw.price ?? 0,
    wholesalePrice: raw.wholesalePrice ?? 0,
    shopifyWeight: raw.shopifyWeight ?? 0,
    weight: raw.weight ?? 0,
    options: Array.isArray(raw.options) ? raw.options : [],
    variants: Array.isArray(raw.variants) ? raw.variants : [],
    collectionNames: Array.isArray(raw.collectionNames)
      ? raw.collectionNames
      : [],
    compositionLabel: raw.compositionLabel ?? "",
    metafields: Array.isArray(raw.metafields) ? raw.metafields : [],
    source: raw.source === "existing" ? "existing" : "new",
    efashionProductId: raw.efashionProductId ?? null,
    readyForMel: Boolean(raw.readyForMel),
    missingFields: Array.isArray(raw.missingFields) ? raw.missingFields : [],
    pendingColors: Array.isArray(raw.pendingColors) ? raw.pendingColors : [],
    colorCollisions: Array.isArray(raw.colorCollisions)
      ? raw.colorCollisions.flatMap((collision) => {
          const colorId = Number(collision?.colorId);
          const names = Array.isArray(collision?.names)
            ? collision.names.map((name) => String(name || "").trim()).filter(Boolean)
            : [];
          if (!Number.isInteger(colorId) || colorId <= 0 || names.length < 2) {
            return [];
          }
          return [{
            colorId,
            officialLabel: String(collision?.officialLabel || "").trim() || `couleur #${colorId}`,
            names,
          }];
        })
      : [],
    pendingCategories: Array.isArray(raw.pendingCategories)
      ? raw.pendingCategories
      : [],
    pendingCompositions: Array.isArray(raw.pendingCompositions)
      ? raw.pendingCompositions
      : [],
    pendingBrands: Array.isArray(raw.pendingBrands) ? raw.pendingBrands : [],
    compositionNeedsReview: Boolean(raw.compositionNeedsReview),
    overrides: raw.overrides ?? {},
    autoMappedFields: Array.isArray(raw.autoMappedFields)
      ? raw.autoMappedFields
      : [],
    brandName: raw.brandName ?? raw.vendor ?? "",
    categoryName: raw.categoryName ?? raw.shopifyCategoryName ?? "",
    colorsLabel: raw.colorsLabel ?? "",
    sizesLabel: raw.sizesLabel ?? "",
    soldByLabel: raw.soldByLabel ?? "",
    photosCount: raw.photosCount ?? raw.images?.length ?? 0,
  };
}

function normalizeCatalog(raw: Partial<ShopifyCatalogPage>): ShopifyCatalogPage {
  const items = (raw.items ?? []).map((item) => normalizeProduct(item));
  const newProducts = (raw.newProducts ?? items.filter((item) => item.source === "new")).map(
    (item) => normalizeProduct(item)
  );

  return {
    items,
    newProducts,
    total: raw.total ?? null,
    hasMore: Boolean(raw.hasMore),
    endCursor: raw.endCursor ?? null,
  };
}

const route = useRoute();
const router = useRouter();
const { success, error } = useNotification();

const initialLoading = ref(true);
const connecting = ref(false);
const catalogLoading = ref(false);
const catalogSyncing = ref(false);
const importingOrders = ref(false);
const syncingProducts = ref(false);
const catalogReady = ref(false);
const catalogScanned = ref(0);
const catalogRevision = ref(0);
const importingProducts = ref(false);
const importProgressLabel = ref("");
const previewLoading = ref(false);
const importPreview = ref<ShopifyImportPreview | null>(null);
const showPrepareConfirm = ref(false);
const resettingAllOverrides = ref(false);
const showPublishConfirm = ref(false);
const showResetAllConfirm = ref(false);
const showConnectHelp = ref(false);
const showConfigurationModal = ref(false);
const shopifySettings = ref<import("@/api/shopify").ShopifySettings>({
  defaultGender: null,
  defaultProvenanceId: null,
  setupCompleted: false,
  autoSyncFromShopify: false,
  autoSyncOrdersToShopify: true,
});
const catalogError = ref("");
const shopDomain = ref("");
const publicInstallUrl = ref<string | null>(null);
const referenceSearch = ref("");
const appliedSearch = ref("");
const page = ref(1);
const pageSize = ref(50);
const catalogPageSizeOptions = [25, 50, 100, 200];
const newTablePage = ref(1);
const newTablePageSize = ref(20);
const connection = ref<ShopifyConnection>({ connected: false });
const catalog = ref<ShopifyCatalogPage>(emptyCatalog());
const editedProduct = ref<ShopifyProduct | null>(null);
const selectedProductIds = ref<string[]>([]);
const selectedProductsById = ref(new Map<string, ShopifyProduct>());
const showBulkComplete = ref(false);
const bulkSheetRef = ref<InstanceType<typeof ShopifyMelBulkSheet> | null>(
  null
);

provide<ShopifyMelBulkSheetContext>("shopifyMelBulkContext", {
  selectedProductIds,
  selectedProductsById,
  onReloadCatalog: () => loadCatalog(),
  success,
  error,
  showBulkComplete,
});

function openBulkComplete() {
  bulkSheetRef.value?.openBulkComplete();
}

const isModalOpen = computed(
  () =>
    showConnectHelp.value ||
    showConfigurationModal.value ||
    editedProduct.value !== null ||
    showBulkComplete.value ||
    showPrepareConfirm.value ||
    showPublishConfirm.value
);
useBodyScrollLock(isModalOpen);

const pendingColorLabels = computed(() => Array.from(new Set(catalog.value.items.flatMap((product) => product.pendingColors || []))));
const pendingCategoryLabels = computed(() => Array.from(new Set(catalog.value.items.flatMap((product) => product.pendingCategories || []))));
const pendingCompositionLabels = computed(() => Array.from(new Set(catalog.value.items.flatMap((product) => product.pendingCompositions || []))));
const pendingBrandLabels = computed(() => Array.from(new Set(catalog.value.items.flatMap((product) => product.pendingBrands || []))));

const paginationTotal = computed(() => {
  const items = catalog.value.items ?? [];
  return (
    catalog.value.total ??
    (page.value - 1) * pageSize.value +
      items.length +
      (catalog.value.hasMore ? 1 : 0)
  );
});
const filteredNewProducts = computed(() => {
  // En recherche : afficher toutes les correspondances (new + already imported).
  // Sinon : uniquement les nouveaux à importer.
  if (appliedSearch.value) {
    return catalog.value.items ?? [];
  }
  return catalog.value.newProducts ?? [];
});
const paginatedNewProducts = computed(() => filteredNewProducts.value);
const filteredProductCount = computed(
  () => filteredNewProducts.value.length
);
const allVisibleNewSelected = computed(
  () =>
    paginatedNewProducts.value.length > 0 &&
    paginatedNewProducts.value.every((product) =>
      selectedProductIds.value.includes(product.id)
    )
);

const bulkSelectionProducts = computed(() =>
  selectedProductIds.value
    .map((productId) => selectedProductsById.value.get(productId))
    .filter((product): product is ShopifyProduct => Boolean(product))
);

const selectedPublishableCount = computed(
  () =>
    bulkSelectionProducts.value.filter((product) => product.readyForMel).length
);

const selectedActiveImportCount = computed(
  () =>
    bulkSelectionProducts.value.filter(
      (product) => product.readyForMel && product.active
    ).length
);

const selectedDraftImportCount = computed(
  () =>
    bulkSelectionProducts.value.filter(
      (product) => product.readyForMel && !product.active
    ).length
);

const selectedPublishableReferences = computed(() =>
  bulkSelectionProducts.value
    .filter((product) => product.readyForMel)
    .map((product) => {
      const reference = product.reference?.trim();
      const name = product.name?.trim();
      const label =
        reference && name
          ? `${reference} · ${name}`
          : reference || name || product.id;
      return {
        label,
        meta: formatPrice(productEffectivePrice(product)),
      };
    })
);

const publishBatchCount = computed(() =>
  Math.ceil(selectedPublishableCount.value / SHOPIFY_IMPORT_BATCH_SIZE)
);

const publishConfirmReminder = computed(() => {
  const priceHint =
    "Rappel : les prix Shopify sont souvent orientés B2C ; assurez-vous que le prix grossiste HT est correct.";
  const draftCount = selectedDraftImportCount.value;
  if (!draftCount) return priceHint;
  const draftHint =
    draftCount === 1
      ? "1 produit est hors ligne sur Shopify : il sera importé en brouillon sur eFashion, sans publication."
      : `${draftCount} produits sont hors ligne sur Shopify : ils seront importés en brouillon sur eFashion, sans publication.`;
  return `${priceHint}\n\n${draftHint}`;
});

const prepareConfirmMessage = computed(() => {
  const preview = importPreview.value;
  if (!preview) return "Aucun produit à préparer.";
  return `${publishConfirmAttention}\n\nSur ${preview.scanned} produits Shopify : ${preview.ready} prêt(s) à importer (${preview.active} à publier, ${preview.draft} en brouillon), ${preview.existing} déjà présent(s) sur eFashion et ${preview.incomplete} incomplet(s).${preview.duplicateReferences ? ` ${preview.duplicateReferences} référence(s) en doublon seront ignorées.` : ""}\n\nLes produits prêts seront traités par lots de ${SHOPIFY_IMPORT_BATCH_SIZE}. Les produits déjà importés ne seront pas recréés.`;
});

const prepareConfirmReminder = computed(() => {
  const priceHint = "Vérifiez les prix grossistes HT avant de continuer.";
  return importPreview.value?.draft
    ? `${priceHint}\n\n${importPreview.value.draft} produit(s) hors ligne sur Shopify seront créés en brouillon sur eFashion.`
    : priceHint;
});

const publishConfirmMessage = computed(() => {
  const batchHint =
    publishBatchCount.value > 1
      ? `\n\nL'import sera traité automatiquement par lots de ${SHOPIFY_IMPORT_BATCH_SIZE} produits (${publishBatchCount.value} lots).`
      : "";
  const total = selectedPublishableCount.value;
  const activeCount = selectedActiveImportCount.value;
  const draftCount = selectedDraftImportCount.value;
  if (!total) {
    return `Aucun produit prêt à importer.${batchHint}`;
  }
  if (draftCount === 0) {
    return `Les ${total} produit(s) prêt(s) sélectionné(s) seront importés et publiés directement sur eFashion. Cette action est définitive pour les références concernées.${batchHint}`;
  }
  if (activeCount === 0) {
    return `Les ${total} produit(s) prêt(s) sélectionné(s) sont hors ligne sur Shopify : ils seront importés en brouillon sur eFashion (non publiés).${batchHint}`;
  }
  return `Les ${total} produit(s) prêt(s) sélectionné(s) seront importés sur eFashion : ${activeCount} publié(s) (en ligne sur Shopify) et ${draftCount} en brouillon (hors ligne sur Shopify). Cette action est définitive pour les références concernées.${batchHint}`;
});

function productEffectivePrice(product: ShopifyProduct): number {
  const override = product.overrides?.price;
  if (typeof override === "number" && override > 0) return override;
  if (product.wholesalePrice && product.wholesalePrice > 0) {
    return product.wholesalePrice;
  }
  return product.price;
}

function refreshSelectedProductsCache(products: ShopifyProduct[]) {
  if (!selectedProductIds.value.length) return;
  const byId = new Map(products.map((product) => [product.id, product]));
  for (const productId of selectedProductIds.value) {
    const product = byId.get(productId);
    if (product) selectedProductsById.value.set(productId, product);
  }
}

function removeImportedSelection(productGids: string[]) {
  if (!productGids.length) return;
  const imported = new Set(productGids);
  selectedProductIds.value = selectedProductIds.value.filter(
    (id) => !imported.has(id)
  );
  const next = new Map(selectedProductsById.value);
  for (const productGid of productGids) next.delete(productGid);
  selectedProductsById.value = next;
}

async function publishSelectedProducts() {
  const rows = bulkSelectionProducts.value
    .filter((product) => product.readyForMel)
    .map((product) => toShopifyImportRow(product));
  if (await importReadyRows(rows)) showPublishConfirm.value = false;
}

async function openPrepareAllConfirm() {
  if (previewLoading.value || importingProducts.value) return;
  previewLoading.value = true;
  importPreview.value = null;
  try {
    const preview = await getShopifyImportPreview();
    if (preview.scanIncomplete) {
      error("Le catalogue dépasse 10 000 produits : le balayage est incomplet. Aucun import global n'a démarré.");
    } else if (!preview.ready) {
      success("Aucun nouveau produit prêt à préparer. Complétez les fiches signalées puis réessayez.");
    } else {
      importPreview.value = preview;
      showPrepareConfirm.value = true;
    }
  } catch (err) {
    error(err instanceof Error ? err.message : "Impossible d'analyser le catalogue Shopify.");
  } finally {
    previewLoading.value = false;
  }
}

async function prepareAllReadyProducts() {
  const gids = importPreview.value?.productGids ?? [];
  if (!gids.length || importingProducts.value) return;
  await importReadyProducts(gids);
  showPrepareConfirm.value = false;
  importPreview.value = null;
}

async function importReadyRows(
  rows: ReturnType<typeof toShopifyImportRow>[],
): Promise<boolean> {
  if (!rows.length || importingProducts.value) return false;
  importingProducts.value = true;
  importProgressLabel.value =
    rows.length > SHOPIFY_IMPORT_BATCH_SIZE
      ? `Préparation de l'import (${rows.length} produits)…`
      : "Mise en ligne en cours…";
  const importedGids: string[] = [];
  try {
    const report = await importShopifyProductRowsInBatches(rows, {
      onBatchReport: (batch) => {
        for (const result of batch.results) {
          if (result.success) importedGids.push(result.shopifyProductGid);
        }
      },
      onBatchProgress: ({
        batchIndex,
        batchCount,
        importedSoFar,
        failedSoFar,
      }) => {
        importProgressLabel.value =
          batchCount > 1
            ? `Lot ${batchIndex}/${batchCount} — ${importedSoFar} importé(s), ${failedSoFar} échec(s)`
            : "Mise en ligne en cours…";
      },
    });
    removeImportedSelection(importedGids);
    if (report.imported > 0) {
      const publishedCount = report.results.filter(
        (result) =>
          result.success &&
          (result.visibility
            ? result.visibility === "online"
            : Boolean(result.published))
      ).length;
      const draftCount = report.results.filter(
        (result) =>
          result.success &&
          (result.visibility
            ? result.visibility === "draft"
            : !result.published)
      ).length;
      let summary = `${report.imported} produit(s) importé(s) sur eFashion`;
      if (publishedCount && draftCount) {
        summary += ` (${publishedCount} publié(s), ${draftCount} en brouillon)`;
      } else if (draftCount && !publishedCount) {
        summary += " en brouillon";
      }
      if (report.failed) summary += `, ${report.failed} en échec`;
      const notes = [
        ...new Set(
          report.results
            .filter((result) => result.success && result.message)
            .map((result) => result.message as string)
        ),
      ];
      success(notes.length === 1 ? `${summary}. ${notes[0]}` : `${summary}.`);
    }
    if (report.failed > 0) {
      const messages = report.results
        .filter((result) => !result.success)
        .map(
          (result) =>
            `${result.shopifyProductGid} : ${result.message || "échec"}`
        )
        .join("\n");
      error(messages);
    }
    await loadCatalog();
    return true;
  } catch (err) {
    if (importedGids.length) {
      removeImportedSelection(importedGids);
      await loadCatalog();
    }
    const message = err instanceof Error ? err.message : "Import impossible.";
    error(importedGids.length
      ? `${importedGids.length} produit(s) importé(s) avant l'interruption. Relancez la préparation pour poursuivre. ${message}`
      : message);
    return false;
  } finally {
    importingProducts.value = false;
    importProgressLabel.value = "";
  }
}

async function importReadyProducts(publishableGids: string[]): Promise<boolean> {
  if (!publishableGids.length || importingProducts.value) return false;
  importingProducts.value = true;
  importProgressLabel.value =
    publishableGids.length > SHOPIFY_IMPORT_BATCH_SIZE
      ? `Préparation de l'import (${publishableGids.length} produits)…`
      : "Mise en ligne en cours…";
  const importedGids: string[] = [];
  try {
    const report = await importShopifyProductsInBatches(publishableGids, {
      onBatchReport: (batch) => {
        for (const result of batch.results) {
          if (result.success) importedGids.push(result.shopifyProductGid);
        }
      },
      onBatchProgress: ({
        batchIndex,
        batchCount,
        importedSoFar,
        failedSoFar,
      }) => {
        importProgressLabel.value =
          batchCount > 1
            ? `Lot ${batchIndex}/${batchCount} — ${importedSoFar} importé(s), ${failedSoFar} échec(s)`
            : "Mise en ligne en cours…";
      },
    });
    removeImportedSelection(importedGids);
    if (report.imported > 0) {
      const publishedCount = report.results.filter(
        (result) =>
          result.success &&
          (result.visibility
            ? result.visibility === "online"
            : Boolean(result.published))
      ).length;
      const draftCount = report.results.filter(
        (result) =>
          result.success &&
          (result.visibility
            ? result.visibility === "draft"
            : !result.published)
      ).length;
      let summary = `${report.imported} produit(s) importé(s) sur eFashion`;
      if (publishedCount && draftCount) {
        summary += ` (${publishedCount} publié(s), ${draftCount} en brouillon)`;
      } else if (draftCount && !publishedCount) {
        summary += " en brouillon";
      }
      if (report.failed) summary += `, ${report.failed} en échec`;
      const notes = [
        ...new Set(
          report.results
            .filter((result) => result.success && result.message)
            .map((result) => result.message as string)
        ),
      ];
      success(notes.length === 1 ? `${summary}. ${notes[0]}` : `${summary}.`);
    }
    if (report.failed > 0) {
      const messages = report.results
        .filter((result) => !result.success)
        .map(
          (result) =>
            `${result.shopifyProductGid} : ${result.message || "échec"}`
        )
        .join("\n");
      error(messages);
    }
    await loadCatalog();
    return true;
  } catch (err) {
    if (importedGids.length) {
      removeImportedSelection(importedGids);
      await loadCatalog();
    }
    const message = err instanceof Error ? err.message : "Import impossible.";
    error(importedGids.length
      ? `${importedGids.length} produit(s) importé(s) avant l'interruption. Relancez la préparation pour poursuivre. ${message}`
      : message);
    return false;
  } finally {
    importingProducts.value = false;
    importProgressLabel.value = "";
  }
}

function closePrepareConfirm() {
  if (importingProducts.value) return;
  showPrepareConfirm.value = false;
  importPreview.value = null;
}

function closePublishConfirm() {
  if (importingProducts.value) return;
  showPublishConfirm.value = false;
}

function closeResetAllConfirm() {
  if (resettingAllOverrides.value) return;
  showResetAllConfirm.value = false;
}

async function resetAllOverrides() {
  if (resettingAllOverrides.value || catalogLoading.value) return;
  resettingAllOverrides.value = true;
  try {
    const report = await resetAllShopifyProductOverrides();
    editedProduct.value = null;
    selectedProductIds.value = [];
    selectedProductsById.value = new Map();
    await loadCatalog();
    success(
      report.cleared > 0
        ? `${report.cleared} fiche(s) remise(s) aux données Shopify d’origine.`
        : "Aucune modification à effacer : le catalogue est déjà à l’état Shopify."
    );
    showResetAllConfirm.value = false;
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de réinitialiser les fiches Shopify."
    );
  } finally {
    resettingAllOverrides.value = false;
  }
}

function openProduct(product: ShopifyProduct) {
  editedProduct.value = product;
}

function toggleProductSelection(productId: string, product: ShopifyProduct) {
  const index = selectedProductIds.value.indexOf(productId);
  if (index >= 0) {
    selectedProductIds.value = selectedProductIds.value.filter(
      (id) => id !== productId
    );
    selectedProductsById.value.delete(productId);
    return;
  }
  selectedProductIds.value = [...selectedProductIds.value, productId];
  selectedProductsById.value.set(productId, product);
}

function toggleAllVisibleNewProducts(event: Event) {
  const checked = (event.target as HTMLInputElement).checked;
  if (!checked) {
    for (const product of paginatedNewProducts.value) {
      selectedProductIds.value = selectedProductIds.value.filter(
        (id) => id !== product.id
      );
      selectedProductsById.value.delete(product.id);
    }
    return;
  }
  for (const product of paginatedNewProducts.value) {
    if (!selectedProductIds.value.includes(product.id)) {
      selectedProductIds.value = [...selectedProductIds.value, product.id];
      selectedProductsById.value.set(product.id, product);
    }
  }
}

function formatPrice(value: number) {
  if (!(value > 0)) return "—";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(value);
}

function formatWeight(value: number) {
  if (!(value > 0)) return "—";
  return `${value.toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })} kg`;
}

function productCoverUrl(product: ShopifyProduct) {
  return resolveShopifyCoverImageUrl(product);
}

function installFromShopify() {
  if (!publicInstallUrl.value) return;
  window.location.href = publicInstallUrl.value;
}

async function connect() {
  connecting.value = true;
  try {
    const { authorizeUrl } = await getShopifyAuthorizeUrl(shopDomain.value);
    window.location.href = authorizeUrl;
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de démarrer la connexion Shopify."
    );
    connecting.value = false;
  }
}

async function exportOrders() {
  if (!isAdmin.value || importingOrders.value) return;
  importingOrders.value = true;
  try {
    const result = await exportShopifyOrders();
    const failed = result.results.filter((item) => item.action === "failed");
    if (failed.length) {
      error(
        `${result.exported} commande(s) envoyée(s), ${failed.length} en échec : ${failed
          .map((item) => `${item.orderName} (${item.reason || "erreur"})`)
          .join(", ")}`,
      );
      return;
    }
    success(`${result.exported} commande(s) envoyée(s) vers Shopify.`);
  } catch (err) {
    error(err instanceof Error ? err.message : "Envoi des commandes vers Shopify impossible.");
  } finally {
    importingOrders.value = false;
  }
}

async function syncLinkedProducts() {
  if (syncingProducts.value) return;
  syncingProducts.value = true;
  let updated = 0;
  let skipped = 0;
  let failed = 0;
  let afterId = 0;
  const notes: string[] = [];
  try {
    do {
      const result = await syncLinkedProductsFromShopify(afterId);
      updated += result.updated;
      skipped += result.skipped;
      failed += result.failed;
      for (const item of result.results) {
        if (item.reason) notes.push(item.reason);
      }
      afterId = result.nextAfterId ?? 0;
    } while (afterId);
    if (failed || skipped || notes.length) {
      error(`${updated} produit(s) synchronisé(s), ${skipped} ignoré(s), ${failed} en échec. ${notes.slice(0, 3).join(' ')}`.trim());
      return;
    }
    success(`${updated} produit(s) déjà associé(s) mis à jour depuis Shopify.`);
  } catch (err) {
    error(err instanceof Error ? err.message : "Synchronisation des produits impossible.");
  } finally {
    syncingProducts.value = false;
  }
}

async function disconnect() {
  if (!window.confirm("Déconnecter cette boutique Shopify ?")) return;
  try {
    await disconnectShopify();
    connection.value = { connected: false };
    catalogReady.value = false;
    catalog.value = emptyCatalog();
    referenceSearch.value = "";
    appliedSearch.value = "";
    success("Boutique Shopify déconnectée.");
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de déconnecter la boutique Shopify."
    );
  }
}

let catalogRequestSequence = 0;
async function loadCatalog() {
  if (!connection.value.connected) return;
  const sequence = ++catalogRequestSequence;
  catalogLoading.value = true;
  catalogError.value = "";
  try {
    let nextCatalog = normalizeCatalog(
      await getShopifyProducts(
        page.value,
        pageSize.value,
        appliedSearch.value || undefined
      )
    );
    if (sequence !== catalogRequestSequence) return;
    const visibleCount = appliedSearch.value
      ? (nextCatalog.items?.length ?? 0)
      : (nextCatalog.newProducts?.length ?? 0);
    if (!appliedSearch.value && page.value > 1 && visibleCount === 0) {
      const total = nextCatalog.total ?? 0;
      const lastPage = Math.max(1, Math.ceil(total / pageSize.value));
      if (lastPage !== page.value) {
        page.value = lastPage;
        nextCatalog = normalizeCatalog(
          await getShopifyProducts(
            page.value,
            pageSize.value,
            appliedSearch.value || undefined
          )
        );
        if (sequence !== catalogRequestSequence) return;
      }
    }
    catalog.value = nextCatalog;
    refreshSelectedProductsCache(catalog.value.newProducts ?? []);
    resetTablePages();
  } catch (err) {
    if (sequence !== catalogRequestSequence) return;
    catalogError.value =
      err instanceof Error
        ? err.message
        : "Impossible de charger le catalogue Shopify.";
  } finally {
    if (sequence === catalogRequestSequence) catalogLoading.value = false;
  }
}

async function syncCatalog(restart = false) {
  if (catalogSyncing.value || !connection.value.connected) return;
  catalogSyncing.value = true;
  catalogError.value = "";
  try {
    let next = await syncShopifyCatalogNextPage(restart);
    catalogScanned.value = next.scanned;
    while (!next.done) {
      next = await syncShopifyCatalogNextPage();
      catalogScanned.value = next.scanned;
    }
    catalogReady.value = next.ready;
    catalogRevision.value += 1;
    page.value = 1;
    await loadCatalog();
    if (restart) success(`${next.scanned} produit(s) synchronisés depuis Shopify.`);
  } catch (caught) {
    catalogError.value = caught instanceof Error ? caught.message : "Synchronisation Shopify impossible.";
  } finally {
    catalogSyncing.value = false;
  }
}

function onSettingsSaved(settings: import("@/api/shopify").ShopifySettings) {
  const initialSetup = !shopifySettings.value.setupCompleted;
  shopifySettings.value = settings;
  if (initialSetup) showConfigurationModal.value = false;
}

async function changePage(nextPage: number) {
  page.value = nextPage;
  resetTablePages();
  await loadCatalog();
}

async function changePageSize(nextSize: number) {
  pageSize.value = nextSize;
  page.value = 1;
  resetTablePages();
  await loadCatalog();
}

function resetTablePages() {
  newTablePage.value = 1;
}

async function submitReferenceSearch() {
  const search = referenceSearch.value.trim();
  if (search === appliedSearch.value) return;
  appliedSearch.value = search;
  page.value = 1;
  resetTablePages();
  await loadCatalog();
}

async function clearReferenceSearch() {
  referenceSearch.value = "";
  if (!appliedSearch.value) return;
  appliedSearch.value = "";
  page.value = 1;
  resetTablePages();
  await loadCatalog();
}

async function handleOAuthReturn() {
  const pending = route.query.pending;
  const connected = route.query.connected;
  const oauthError = route.query.error;

  if (typeof pending === "string" && pending) {
    try {
      await claimShopifyInstall(pending);
      success("Boutique Shopify connectée.");
    } catch (err) {
      error(
        err instanceof Error
          ? err.message
          : "Impossible de terminer la connexion Shopify."
      );
    }
    await router.replace({ name: "services/shopify" });
    return;
  }

  if (!connected && !oauthError) return;

  if (connected === "1") {
    success("Boutique Shopify connectée.");
  } else if (typeof oauthError === "string" && oauthError) {
    error(oauthError);
  }

  await router.replace({ name: "services/shopify" });
}

onMounted(async () => {
  await handleOAuthReturn();
  try {
    connection.value = await getShopifyConnection();
    publicInstallUrl.value = connection.value.publicInstallUrl || null;
    if (connection.value.connected) {
      shopDomain.value = connection.value.shopUrl || "";
      shopifySettings.value = await getShopifySettings();
      const status = await getShopifyCatalogStatus();
      catalogReady.value = status.ready;
      catalogScanned.value = status.scanned;
      await loadCatalog();
      if (!shopifySettings.value.setupCompleted) showConfigurationModal.value = true;
      if (!status.ready || status.syncing) void syncCatalog();
    }
  } catch (err) {
    error(
      err instanceof Error
        ? err.message
        : "Impossible de charger la connexion Shopify."
    );
  } finally {
    initialLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "Import Shopify",
      subtitle: "Connectez votre boutique Shopify et consultez votre catalogue"
    }),
    _createElementVNode("div", _hoisted_2, [
      (initialLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl text-green-600" }, null, -1)
          ])))
        : (!connection.value.connected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "text-lg font-semibold text-black mb-2" }, " Connecter votre boutique Shopify ", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm text-gray-600 mb-2" }, " L'installation commence sur Shopify. Vous y choisissez votre boutique, vous autorisez eFashion, puis vous revenez ici. ", -1)),
              _createElementVNode("button", {
                type: "button",
                class: "mb-5 inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-800",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConnectHelp.value = true))
              }, _cache[14] || (_cache[14] = [
                _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1),
                _createTextVNode(" Comment fonctionne la connexion Shopify ? ")
              ])),
              (publicInstallUrl.value)
                ? (_openBlock(), _createBlock(ActionButton, {
                    key: 0,
                    label: "Installer sur Shopify",
                    icon: "fab fa-shopify",
                    variant: "success",
                    onClick: installFromShopify
                  }))
                : (_openBlock(), _createElementBlock("p", _hoisted_5, " Le lien d'installation sera disponible lorsque Shopify aura validé l'application. ")),
              _createElementVNode("details", _hoisted_6, [
                _cache[15] || (_cache[15] = _createElementVNode("summary", { class: "cursor-pointer text-sm text-gray-600" }, " Connexion de la boutique déjà reliée à eFashion ", -1)),
                _createElementVNode("form", {
                  class: "mt-4 space-y-4",
                  onSubmit: _withModifiers(connect, ["prevent"])
                }, [
                  _createVNode(BaseInput, {
                    modelValue: shopDomain.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shopDomain).value = $event)),
                    modelModifiers: { trim: true },
                    label: "Nom de la boutique",
                    placeholder: "ma-boutique ou ma-boutique.myshopify.com",
                    required: ""
                  }, null, 8, ["modelValue"]),
                  _createVNode(ActionButton, {
                    type: "submit",
                    label: "Connecter avec Shopify",
                    icon: "fab fa-shopify",
                    variant: "secondary",
                    loading: connecting.value,
                    disabled: connecting.value || !shopDomain.value
                  }, null, 8, ["loading", "disabled"])
                ], 32)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                    _createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-green-500" }),
                    _createElementVNode("h2", { class: "font-semibold text-black" }, "Boutique connectée")
                  ], -1)),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(connection.value.shopUrl), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(ActionButton, {
                    label: "Actualiser le catalogue",
                    icon: "fas fa-sync-alt",
                    variant: "primary",
                    size: "sm",
                    loading: catalogSyncing.value,
                    disabled: catalogSyncing.value || resettingAllOverrides.value,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (syncCatalog(catalogReady.value)))
                  }, null, 8, ["loading", "disabled"]),
                  _createVNode(ActionButton, {
                    label: "Revenir aux données Shopify",
                    icon: "fas fa-undo",
                    variant: "secondary",
                    size: "sm",
                    loading: resettingAllOverrides.value,
                    disabled: catalogLoading.value || resettingAllOverrides.value,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (showResetAllConfirm.value = true))
                  }, null, 8, ["loading", "disabled"]),
                  (isAdmin.value)
                    ? (_openBlock(), _createBlock(ActionButton, {
                        key: 0,
                        label: "Envoyer les commandes",
                        icon: "fas fa-file-import",
                        variant: "primary",
                        size: "sm",
                        loading: importingOrders.value,
                        disabled: catalogSyncing.value || resettingAllOverrides.value || importingOrders.value,
                        onClick: exportOrders
                      }, null, 8, ["loading", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(ActionButton, {
                    label: "Synchroniser les produits",
                    icon: "fas fa-download",
                    variant: "primary",
                    size: "sm",
                    loading: syncingProducts.value,
                    disabled: catalogSyncing.value || resettingAllOverrides.value || importingOrders.value || syncingProducts.value,
                    onClick: syncLinkedProducts
                  }, null, 8, ["loading", "disabled"]),
                  _createVNode(ActionButton, {
                    label: "Configuration Shopify",
                    icon: "fas fa-cog",
                    variant: "secondary",
                    size: "sm",
                    disabled: catalogLoading.value || resettingAllOverrides.value,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showConfigurationModal.value = true))
                  }, null, 8, ["disabled"]),
                  _createVNode(ActionButton, {
                    label: "Déconnecter",
                    icon: "fas fa-unlink",
                    variant: "secondary",
                    size: "sm",
                    disabled: catalogLoading.value || catalogSyncing.value || resettingAllOverrides.value,
                    onClick: disconnect
                  }, null, 8, ["disabled"])
                ])
              ]),
              (catalogSyncing.value || !catalogReady.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (catalogSyncing.value)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(catalogSyncing.value ? `Synchronisation Shopify : ${catalogScanned.value} produit(s) enregistrés…` : "Le catalogue local n'est pas encore synchronisé. Cliquez sur Actualiser le catalogue pour reprendre."), 1)
                  ]))
                : _createCommentVNode("", true),
              (catalogError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-exclamation-circle mr-2" }, null, -1)),
                    _createTextVNode(_toDisplayString(catalogError.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(filteredProductCount.value) + " affiché(s) ", 1),
                _createElementVNode("form", {
                  class: "flex flex-1 items-center gap-2 min-w-[200px] max-w-lg",
                  onSubmit: _withModifiers(submitReferenceSearch, ["prevent"])
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", {
                    for: "shopify-reference-search",
                    class: "sr-only"
                  }, "Rechercher un SKU", -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-search absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-[10px]" }, null, -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "shopify-reference-search",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((referenceSearch).value = $event)),
                      type: "text",
                      autocomplete: "off",
                      placeholder: "Contient le SKU…",
                      class: "w-full h-8 pl-7 pr-7 border border-gray-300 rounded-md text-xs bg-white focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500"
                    }, null, 512), [
                      [
                        _vModelText,
                        referenceSearch.value,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (referenceSearch.value || appliedSearch.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          "aria-label": "Effacer la recherche",
                          class: "absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-700",
                          onClick: clearReferenceSearch
                        }, _cache[20] || (_cache[20] = [
                          _createElementVNode("i", { class: "fas fa-times text-[10px]" }, null, -1)
                        ])))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "h-8 rounded-md bg-blue-600 px-3 text-xs font-medium text-white disabled:opacity-50",
                    disabled: catalogLoading.value
                  }, "Rechercher", 8, _hoisted_16)
                ], 32),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(ActionButton, {
                    label: "Préparer tous les produits prêts",
                    icon: "fas fa-magic",
                    variant: "success",
                    size: "sm",
                    loading: previewLoading.value || (importingProducts.value && showPrepareConfirm.value),
                    disabled: previewLoading.value || importingProducts.value || catalogLoading.value || !catalogReady.value || !shopifySettings.value.setupCompleted,
                    onClick: openPrepareAllConfirm
                  }, null, 8, ["loading", "disabled"]),
                  _createVNode(ActionButton, {
                    label: `Modifier les fiches en masse (${selectedProductIds.value.length})`,
                    icon: "fas fa-layer-group",
                    variant: "primary",
                    size: "sm",
                    disabled: selectedProductIds.value.length === 0,
                    onClick: openBulkComplete
                  }, null, 8, ["label", "disabled"]),
                  _createVNode(ActionButton, {
                    label: `Mettre en ligne (${selectedPublishableCount.value})`,
                    icon: "fas fa-cloud-upload-alt",
                    variant: "success",
                    size: "sm",
                    loading: importingProducts.value && !showPublishConfirm.value,
                    disabled: importingProducts.value || selectedPublishableCount.value === 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showPublishConfirm.value = true))
                  }, null, 8, ["label", "loading", "disabled"])
                ])
              ]),
              _createElementVNode("section", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", _hoisted_20, [
                    _createTextVNode(_toDisplayString(appliedSearch.value
                  ? "Résultats de recherche"
                  : "Nouveaux produits") + " ", 1),
                    _createElementVNode("span", _hoisted_21, " (" + _toDisplayString(filteredNewProducts.value.length) + ") ", 1)
                  ]),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(appliedSearch.value
                  ? "Correspondances exactes (contient) sur tout le catalogue Shopify."
                  : "Cochez plusieurs produits pour les compléter en masse, ou cliquez sur une ligne pour éditer une fiche."), 1)
                ]),
                (filteredNewProducts.value.length > 0 || catalog.value.hasMore)
                  ? (_openBlock(), _createBlock(UnifiedPagination, {
                      key: 0,
                      variant: "dashboard",
                      "total-items": Math.max(filteredNewProducts.value.length, paginationTotal.value),
                      "current-page": page.value,
                      "items-per-page": pageSize.value,
                      "items-per-page-options": catalogPageSizeOptions,
                      "show-items-per-page": true,
                      "item-label": "produits Shopify",
                      onPageChange: changePage,
                      onItemsPerPageChange: changePageSize
                    }, null, 8, ["total-items", "current-page", "items-per-page"]))
                  : _createCommentVNode("", true),
                (catalogLoading.value && !(catalog.value.newProducts?.length))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _cache[23] || (_cache[23] = [
                      _createElementVNode("i", { class: "fas fa-spinner fa-spin mr-2" }, null, -1),
                      _createTextVNode(" Chargement du catalogue… ")
                    ])))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("table", _hoisted_25, [
                        _createElementVNode("thead", _hoisted_26, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_27, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: allVisibleNewSelected.value,
                                disabled: paginatedNewProducts.value.length === 0,
                                "aria-label": "Sélectionner tous les produits de la page",
                                class: "w-4 h-4 rounded border-gray-300",
                                onChange: toggleAllVisibleNewProducts
                              }, null, 40, _hoisted_28)
                            ]),
                            _cache[24] || (_cache[24] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "État", -1)),
                            _cache[25] || (_cache[25] = _createElementVNode("th", { class: "px-3 py-3 w-14" }, "Photo", -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "SKU", -1)),
                            _cache[27] || (_cache[27] = _createElementVNode("th", { class: "px-3 py-3 min-w-[180px]" }, "Titre", -1)),
                            _cache[28] || (_cache[28] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "Marque", -1)),
                            _cache[29] || (_cache[29] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "Catégorie", -1)),
                            _cache[30] || (_cache[30] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap text-right" }, " Prix HT ", -1)),
                            _cache[31] || (_cache[31] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap text-right" }, "Poids", -1)),
                            _cache[32] || (_cache[32] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "Vendu par", -1)),
                            _cache[33] || (_cache[33] = _createElementVNode("th", { class: "px-3 py-3 min-w-[120px]" }, "Couleurs", -1)),
                            _cache[34] || (_cache[34] = _createElementVNode("th", { class: "px-3 py-3 min-w-[100px]" }, "Tailles", -1)),
                            _cache[35] || (_cache[35] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap text-center" }, " Photos ", -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("th", { class: "px-3 py-3 whitespace-nowrap" }, "Statut Shopify", -1)),
                            _cache[37] || (_cache[37] = _createElementVNode("th", { class: "px-3 py-3 min-w-[160px]" }, "Manquants", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_29, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedNewProducts.value, (product) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: `new-${product.id}`,
                              class: "group cursor-pointer hover:bg-green-50/60",
                              title: 
                    product.readyForMel
                      ? 'Cliquer pour vérifier la fiche'
                      : 'Cliquer pour compléter la fiche'
                  ,
                              onClick: ($event: any) => (openProduct(product))
                            }, [
                              _createElementVNode("td", {
                                class: "px-3 py-3 sticky left-0 bg-white group-hover:bg-green-50/60",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: selectedProductIds.value.includes(product.id),
                                  title: "Sélectionner ce produit",
                                  class: "w-4 h-4 rounded border-gray-300",
                                  onChange: ($event: any) => (toggleProductSelection(product.id, product))
                                }, null, 40, _hoisted_31)
                              ]),
                              _createElementVNode("td", _hoisted_32, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["inline-flex items-center gap-1.5 text-xs font-medium", 
                        product.readyForMel ? 'text-green-700' : 'text-red-700'
                      ]),
                                  title: 
                        product.readyForMel
                          ? 'Prêt pour la MEL'
                          : 'Fiche incomplète'
                      
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["inline-block w-2.5 h-2.5 rounded-full", 
                          product.readyForMel ? 'bg-green-500' : 'bg-red-500'
                        ])
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(product.readyForMel ? "Prêt" : "Incomplet"), 1)
                                ], 10, _hoisted_33)
                              ]),
                              _createElementVNode("td", _hoisted_34, [
                                (productCoverUrl(product))
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: productCoverUrl(product)!,
                                      alt: product.name || product.reference,
                                      class: "w-10 h-10 rounded object-cover border border-gray-200"
                                    }, null, 8, _hoisted_35))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_36, _cache[38] || (_cache[38] = [
                                      _createElementVNode("i", { class: "fas fa-image text-xs" }, null, -1)
                                    ])))
                              ]),
                              _createElementVNode("td", _hoisted_37, _toDisplayString(product.reference || "—"), 1),
                              _createElementVNode("td", _hoisted_38, _toDisplayString(product.name || "—"), 1),
                              _createElementVNode("td", _hoisted_39, [
                                _createTextVNode(_toDisplayString(product.brandName || "—") + " ", 1),
                                (product.pendingBrands?.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, "mapping à créer"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_41, [
                                _createTextVNode(_toDisplayString(product.categoryName || "—") + " ", 1),
                                (product.pendingCategories?.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "mapping à créer"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_43, _toDisplayString(formatPrice(product.price)), 1),
                              _createElementVNode("td", _hoisted_44, _toDisplayString(formatWeight(product.weight)), 1),
                              _createElementVNode("td", _hoisted_45, _toDisplayString(product.soldByLabel || "—"), 1),
                              _createElementVNode("td", _hoisted_46, _toDisplayString(product.colorsLabel || "—"), 1),
                              _createElementVNode("td", _hoisted_47, _toDisplayString(product.sizesLabel || "—"), 1),
                              _createElementVNode("td", _hoisted_48, _toDisplayString(product.photosCount), 1),
                              _createElementVNode("td", _hoisted_49, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["px-2 py-1 rounded-full text-xs font-medium whitespace-nowrap", 
                        product.active
                          ? 'bg-green-100 text-green-700'
                          : 'bg-gray-100 text-gray-700'
                      ])
                                }, _toDisplayString(product.active ? "En ligne" : "Hors ligne"), 3)
                              ]),
                              _createElementVNode("td", _hoisted_50, [
                                (!(product.missingFields?.length))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, " Fiche complète "))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: "line-clamp-2",
                                      title: (product.missingFields ?? []).join(', ')
                                    }, _toDisplayString((product.missingFields ?? []).join(", ")), 9, _hoisted_52))
                              ])
                            ], 8, _hoisted_30))
                          }), 128)),
                          (!catalogLoading.value && filteredNewProducts.value.length === 0)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_53, _cache[39] || (_cache[39] = [
                                _createElementVNode("td", {
                                  colspan: "15",
                                  class: "px-4 py-8 text-center text-gray-500"
                                }, " Aucun nouveau produit sur cette page. ", -1)
                              ])))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])),
                (filteredNewProducts.value.length > 0 || catalog.value.hasMore)
                  ? (_openBlock(), _createBlock(UnifiedPagination, {
                      key: 3,
                      variant: "dashboard",
                      "total-items": Math.max(filteredNewProducts.value.length, paginationTotal.value),
                      "current-page": page.value,
                      "items-per-page": pageSize.value,
                      "items-per-page-options": catalogPageSizeOptions,
                      "show-items-per-page": true,
                      "item-label": "produits Shopify",
                      onPageChange: changePage,
                      onItemsPerPageChange: changePageSize
                    }, null, 8, ["total-items", "current-page", "items-per-page"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
    ]),
    _createVNode(ShopifyMelProductSheet, {
      modelValue: editedProduct.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editedProduct).value = $event)),
      catalog: catalog.value,
      "onUpdate:catalog": _cache[9] || (_cache[9] = ($event: any) => ((catalog).value = $event)),
      "reload-catalog": loadCatalog,
      onSuccess: _unref(success),
      onError: _unref(error)
    }, null, 8, ["modelValue", "catalog", "onSuccess", "onError"]),
    _createVNode(ShopifyMelBulkSheet, {
      ref_key: "bulkSheetRef",
      ref: bulkSheetRef
    }, null, 512),
    _createVNode(ShopifyConfigurationModal, {
      visible: showConfigurationModal.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((showConfigurationModal).value = $event)),
      "shop-url": connection.value.shopUrl,
      "required-setup": !shopifySettings.value.setupCompleted,
      "catalog-ready": catalogReady.value,
      "catalog-revision": catalogRevision.value,
      "pending-colors": pendingColorLabels.value,
      "pending-categories": pendingCategoryLabels.value,
      "pending-compositions": pendingCompositionLabels.value,
      "pending-brands": pendingBrandLabels.value,
      onChanged: loadCatalog,
      onSettingsSaved: onSettingsSaved
    }, null, 8, ["visible", "shop-url", "required-setup", "catalog-ready", "catalog-revision", "pending-colors", "pending-categories", "pending-compositions", "pending-brands"]),
    _createVNode(ConfirmModal, {
      show: showPublishConfirm.value,
      title: "Confirmer la mise en ligne",
      attention: publishConfirmAttention,
      message: publishConfirmMessage.value,
      reminder: publishConfirmReminder.value,
      "confirm-text": "Mettre en ligne",
      "loading-text": "Mise en ligne…",
      references: selectedPublishableReferences.value,
      "confirm-loading": importingProducts.value,
      "progress-label": importProgressLabel.value,
      "show-attention-icon": true,
      "lock-background-scroll": true,
      "max-width-class": "max-w-lg",
      onConfirm: publishSelectedProducts,
      onCancel: closePublishConfirm
    }, null, 8, ["show", "message", "reminder", "references", "confirm-loading", "progress-label"]),
    _createVNode(ConfirmModal, {
      show: showPrepareConfirm.value,
      title: "Préparer tous les produits prêts",
      message: prepareConfirmMessage.value,
      reminder: prepareConfirmReminder.value,
      "confirm-text": "Préparer les produits",
      "loading-text": "Préparation en cours…",
      "confirm-loading": importingProducts.value,
      "progress-label": importProgressLabel.value,
      "show-attention-icon": true,
      "lock-background-scroll": true,
      "max-width-class": "max-w-lg",
      onConfirm: prepareAllReadyProducts,
      onCancel: closePrepareConfirm
    }, null, 8, ["show", "message", "reminder", "confirm-loading", "progress-label"]),
    _createVNode(ConfirmModal, {
      show: showResetAllConfirm.value,
      title: "Revenir aux données Shopify ?",
      message: "Les fiches reprennent les données Shopify du moment : prix, poids, photos, couleurs, composition, catégorie et marque.",
      "confirm-text": "Réinitialiser tout",
      "confirm-button-class": "bg-red-600 hover:bg-red-700 focus:ring-red-500",
      "loading-text": "Réinitialisation…",
      "confirm-loading": resettingAllOverrides.value,
      "show-attention-icon": true,
      "lock-background-scroll": true,
      "max-width-class": "max-w-lg",
      onConfirm: resetAllOverrides,
      onCancel: closeResetAllConfirm
    }, null, 8, ["show", "confirm-loading"]),
    (showConnectHelp.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("button", {
            type: "button",
            class: "absolute inset-0 bg-black/40",
            "aria-label": "Fermer",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (showConnectHelp.value = false))
          }),
          _createElementVNode("div", _hoisted_55, [
            _cache[40] || (_cache[40] = _createElementVNode("h3", {
              id: "shopify-connect-help-title",
              class: "text-lg font-semibold text-black mb-4"
            }, " Connexion Shopify ", -1)),
            _cache[41] || (_cache[41] = _createElementVNode("ol", { class: "list-decimal list-inside space-y-2 text-sm text-gray-700" }, [
              _createElementVNode("li", null, "Cliquez sur « Installer sur Shopify »."),
              _createElementVNode("li", null, "Choisissez votre boutique sur la page Shopify."),
              _createElementVNode("li", null, " Autorisez eFashion à lire votre catalogue (produits, variantes, stock). "),
              _createElementVNode("li", null, " Revenez sur eFashion et connectez-vous : la boutique se rattache à votre compte. ")
            ], -1)),
            _cache[42] || (_cache[42] = _createElementVNode("p", { class: "mt-4 text-sm text-gray-600" }, " Vous n’avez pas besoin de créer une application dans votre admin Shopify ni de copier une clé API. ", -1)),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(ActionButton, {
                label: "Compris",
                variant: "primary",
                size: "sm",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (showConnectHelp.value = false))
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})